import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import placeholder from '@sorare/core/src/assets/club/shield_none.png';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

import { BaseLayout } from 'components/rivals/Onboarding/FavoriteClubSelection/ClubSelectionDialog/BaseLayout';

import { WelcomeToSorare_club } from './__generated__/index.graphql';

type Props = { club?: WelcomeToSorare_club };
export const WelcomeToSorare = ({ club }: Props) => {
  return (
    <BaseLayout
      color={club?.styleGuideColor}
      title={
        <FormattedMessage
          id="ClubSelectionDialog.title"
          defaultMessage="Welcome to Sorare"
        />
      }
      subtitle={
        <FormattedMessage
          id="ClubSelectionDialog.subtitle"
          defaultMessage="A fantasy game based on real life scoring."
        />
      }
      content={
        <Horizontal center>
          <img
            src={club?.pictureUrl || placeholder}
            alt={club?.name}
            width={160}
          />
        </Horizontal>
      }
    />
  );
};

WelcomeToSorare.fragments = {
  club: gql`
    fragment WelcomeToSorare_club on Club {
      slug
      id
      styleGuideColor
      pictureUrl
      name
    }
  ` as TypedDocumentNode<WelcomeToSorare_club>,
};
